/// <amd-module name="Release/DeploymentsSection/Actions/DeploymentsComponentActions" />
import { Action } from "VSS/Reflux/Action";

import { Favorite } from "Favorites/Common/Contracts/Favorite";
import * as RMContracts from "Release/Client/Contracts/Release";
export class DeploymentsComponentActions {

    constructor() {
        this.initialize();
    }
    public static getKey(): string {
        return "deployments-section-actions";
    }

    public initialize(instanceId?: string): void {
        this._setReleases = new Action<RMContracts.Release>();
        this._setReleases2 = new Action<RMContracts.Release[]>();
        this._setAutoTriggerIssues = new Action<RMContracts.AutoTriggerIssue[]>();
        this._fetchFavorites = new Action<Favorite[]>();
        this._incrementRenderIndex = new Action<void>();
        this._maximizeRenderIndex = new Action<void>();
        this._resetView = new Action<void>();
        this._setDeploymentsData = new Action<any>();
        this._toggleExpandIssues = new Action<void>();
    }

    public get setRelease(): Action<RMContracts.Release> {
        return this._setReleases;
    }

    public get setReleases(): Action<RMContracts.Release[]> {
        return this._setReleases2;
    }

    public get fetchFavorites(): Action<Favorite[]> {
        return this._fetchFavorites;
    }

    public get incrementRenderIndex(): Action<void> {
        return this._incrementRenderIndex;
    }

    public get maximizeRenderIndex(): Action<void> {
        return this._maximizeRenderIndex;
    }

    public get resetView(): Action<void> {
        return this._resetView;
    }

    public get setAutoTriggerIssues(): Action<RMContracts.AutoTriggerIssue[]> {
        return this._setAutoTriggerIssues;
    }

    public get setDeploymentsData(): Action<any> {
        return this._setDeploymentsData;
    }

    public get toggleExpandIssues(): Action<void> {
        return this._toggleExpandIssues;
    }

    private _setReleases: Action<RMContracts.Release>;
    private _setReleases2: Action<RMContracts.Release[]>;
    private _setAutoTriggerIssues: Action<RMContracts.AutoTriggerIssue[]>;
    private _fetchFavorites: Action<Favorite[]>;
    private _incrementRenderIndex: Action<void>;
    private _maximizeRenderIndex: Action<void>;
    private _resetView: Action<void>;
    private _setDeploymentsData: Action<any>;
    private _toggleExpandIssues: Action<void>;
}
